import { createVueApp } from "@saflib/vue";
import { setClientName } from "@saflib/links";
import App from "./AccountApp.vue";
import { router } from "./router.ts";
import { account_strings } from "./strings.ts";
import {
  vuetifyConfig,
  sentryCallback,
  initClientObservability,
  powerUpMfaRequiredHref,
} from "@vendata/power-up-clients-common";
import "vuetify/styles";

export const main = () => {
  setClientName("account");
  initClientObservability();
  createVueApp(App, {
    vuetifyConfig,
    router,
    callback: sentryCallback,
    i18nMessages: {
      ...account_strings,
    },
    mfaRequiredHref: powerUpMfaRequiredHref(),
  });
};
